import { Stack, styled } from "@tamagui/core";
import { getElevation } from "./getElevation";
const fullscreenStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
const variants = {
  fullscreen: {
    true: fullscreenStyle
  },
  elevation: {
    "...size": getElevation
  }
};
const YStack = styled(Stack, {
  flexDirection: "column",
  variants
});
const XStack = styled(Stack, {
  flexDirection: "row",
  variants
});
const ZStack = styled(
  YStack,
  {
    position: "relative"
  },
  {
    neverFlatten: true,
    isZStack: true
  }
);
export {
  XStack,
  YStack,
  ZStack,
  fullscreenStyle
};
//# sourceMappingURL=Stacks.js.map
